import React from 'react';
import PropTypes from 'prop-types';
import { usePropsContext } from '@uhg-abyss/web/hooks/usePropsContext';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';

export const Corporates = ({
  corporates,
  selectedProvider,
  setSelectedProvider,
  setAllowProviderSearch,
  handleNewCorporateSelection,
}) => {
  const { events } = usePropsContext();
  const { organizationId } = selectedProvider;

  const handleCorpOwnerChange = (selectedMpin) => {
    const corporateProviderMpin = selectedMpin || null;
    let newCorpOwner;
    if (corporateProviderMpin) {
      newCorpOwner = (corporates || []).find(
        (corp) => corp.mpin === corporateProviderMpin
      );
    }

    if (selectedProvider.uniqueId !== newCorpOwner.uniqueId) {
      const newData = {
        ...(organizationId && {
          organizationId,
        }),
        corporateProviderLastName: newCorpOwner.lastName,
        corporateProviderName: newCorpOwner.name,
        corporateProviderMpin,
        ia: newCorpOwner.ia,
        paa: newCorpOwner.paa,
        ...(newCorpOwner.userId && {
          userId: newCorpOwner.userId,
        }),
        ...(newCorpOwner.uhcProviderId && {
          uhcProviderId: newCorpOwner.uhcProviderId,
        }),
        ...(newCorpOwner.uniqueId && {
          uniqueId: newCorpOwner.uniqueId,
        }),
        ...(newCorpOwner.isThirdParty && {
          isThirdParty: newCorpOwner.isThirdParty,
        }),
      };
      setSelectedProvider(newData);
      handleNewCorporateSelection(newData);

      events.onCorporateChange(newData);
    }
    setAllowProviderSearch(true);
  };

  return (
    <SelectInput
      enableOutsideScroll
      isSearchable
      placeholder='Select Corporate Tax ID Owner...'
      label='Corporate Tax ID Owner'
      validators={{ required: true }}
      value={selectedProvider.corporateProviderMpin}
      isDisabled={corporates.length === 0}
      onChange={handleCorpOwnerChange}
      valueKey='mpin'
      options={corporates}
    />
  );
};

Corporates.propTypes = {
  corporates: PropTypes.arrayOf(PropTypes.shape({})),
  selectedProvider: PropTypes.shape({
    organizationId: PropTypes.string,
    corporateProviderMpin: PropTypes.string,
    id: PropTypes.string,
    uniqueId: PropTypes.string,
  }),
  setSelectedProvider: PropTypes.func.isRequired,
  setAllowProviderSearch: PropTypes.func.isRequired,
  handleNewCorporateSelection: PropTypes.func.isRequired,
};

Corporates.defaultProps = {
  corporates: [],
  selectedProvider: null,
};
